export const DenialReasonFieldsSectionTestIds = {
  NEW_DENIAL_REASON_SELECT: 'denial-reasons-section.new-denial-reason-select',
};
